<template>
  <div
    class="icon-wrapper"
    :class="{ thin: strokeWidth === 'thin', thick: strokeWidth === 'thick', thicker: strokeWidth === 'thicker' }"
    @click="$emit('click', $event)"
  >
    <IconifyIcon :icon="icon" :width="_iconWidth" :height="_iconWidth" :rotate="rotate"></IconifyIcon>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'n-icon'
})
export default class NIcon extends Vue {
  @Prop({ type: String }) private icon!: string
  @Prop({ type: String, validator: (prop: string) => ['xs', 's', 'm', 'l', 'xl', 'xxl'].includes(prop), default: 'm' })
  private size!: string
  @Prop({ type: String, default: '0' }) private rotate?: string
  @Prop({
    type: String,
    default: 'normal',
    validator: (prop: string) => ['thin', 'normal', 'thick', 'thicker'].includes(prop)
  })
  private strokeWidth?: string

  private get _iconWidth() {
    switch (this.size) {
      case 'xs':
        return '12px'
      case 's':
        return '16px'
      case 'l':
        return '24px'
      case 'xl':
        return '32px'
      case 'xxl':
        return '40px'
      default:
        return '20px'
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/core/_colors.scss' as *;
@use '@/assets/styles/core/_spacing.scss' as *;
@use '@/assets/styles/core/_typography.scss' as *;

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  &.thin {
    svg ::v-deep path {
      stroke-width: 1.5;
    }
  }

  &.thick {
    svg ::v-deep path {
      stroke-width: 3;
    }
  }

  &.thicker {
    svg ::v-deep path {
      stroke-width: 4.5;
    }
  }
}
</style>
